import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="site-creation-form"
export default class extends Controller {
  static targets = ["submitBtn"]

  connect() {
    this.form = this.element
    this.form.addEventListener("submit", this.showLoading.bind(this))
  }

  showLoading(event) {
    if (this.hasSubmitBtnTarget) {
      this.submitBtnTarget.disabled = true
      this.submitBtnTarget.classList.add("opacity-50", "cursor-not-allowed")
    }
    // Show global spinner overlay
    const spinner = document.querySelector("[data-turbo-loading]")
    if (spinner) spinner.classList.remove("hidden")
  }
}
